import { render, staticRenderFns } from "./editinstitution.vue?vue&type=template&id=06a3f494&scoped=true&"
import script from "./editinstitution.vue?vue&type=script&lang=js&"
export * from "./editinstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a3f494",
  null
  
)

export default component.exports